import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './sampleDevelopmentNl.style';

import { CheckBoxFastField, TextFieldFastField } from '../../../components';

interface SamDevNlFinishingFrontProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlFinishingFront: React.FC<SamDevNlFinishingFrontProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <Typography className={classes.numberTitle} display="inline">
            Finishing
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="finishCoatingFront"
            label="Front"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <Typography className={classes.numberTitle} display="inline">
            1. Coating
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfFilmLaminate"
            label="Laminate Film"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfFilmMatt" label="Matt" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfFilmGloss" label="Gloss" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfFilmHalogram"
            label="Halogram"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfFilmOther" label="Other" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <Typography className={classes.numberTitle} display="inline" />
        </Grid>
        <Grid item xs={4}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemCemical"
            label="Chemical"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemWaterBase"
            label="Water Base"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemOilBase"
            label="Oil Base"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfChemVanish" label="UV" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfChemSpot" label="Spot" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfChemSpotMatt" label="Matt" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotSuperMatt"
            label="Supper Matt"
          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotSemiGloss"
            label="Semi Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotGloss"
            label="Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotHighGloss"
            label="High Gloss"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotTexture"
            label="Texture"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotCalendering"
            label="Calendering"
          />
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={4} />
        <Grid item xs={1}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemSpotOther"
            label="Other"
          />
        </Grid>
        <Grid item xs={3}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckboxOther}
            name="fcfChemSpotOtherData"
            label="Other"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullArea"
            label="Full Area"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaMatt"
            label="Matt"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaSuperMatt"
            label="Supper Matt"
          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaSemiGloss"
            label="Semi Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaGloss"
            label="Gloss"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaHighGloss"
            label="High Gloss"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4} />
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaTexture"
            label="Texture"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaCalendering"
            label="Calendering"
          />
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={4} />
        <Grid item xs={1}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfChemFullAreaOther"
            label="Other"
          />
        </Grid>
        <Grid item xs={3}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckboxOther}
            name="fcfChemFullAreaOtherData"
            label="Other"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfBlister" label="Blister" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfBlisterPet" label="PET" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfBlisterPvc" label="PVC" />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfSilkscreen"
            label="Silkscreen"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="fcfSilkFullArea"
            label="Full Area"
          />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfSilkSpot" label="Spot" />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfSilkMatt" label="Matt" />
        </Grid>
        <Grid item xs={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfSilkGloss" label="Gloss" />
        </Grid>
        <Grid item xs={1}>
          <CheckBoxFastField disabled={isCrtLocked} name="fcfSilkOthers" label="Other" />
        </Grid>
        <Grid item xs={3}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckboxOther}
            name="fcfSilkOthersData"
            label="Other"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={2}>
          <Typography className={classes.numberTitle} display="inline">
            2. Die-Cut
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <CheckBoxFastField disabled={isCrtLocked} name="dieCutFront" label="Front" />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3} />
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutFHold"
            label="ปั๊มรู (Hold)"
          />
        </Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutFPerforate"
            label="ปั๊มปรุ (Perforate)"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3} />
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutFShape"
            label="ปั๊มตามรูป (Shape)"
          />
        </Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutFFoldLine"
            label="ปั๊มพับ (Fold Line)"
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={3}></Grid>
        <Grid item xs={3}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="dieCutFEmboss"
            label="ปั๊มนูน (Emboss)"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SampleDevelopmentNlFinishingFront;
